import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import theme from "@/services/theme";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: theme.branding.color
            },
            dark: {
                primary: theme.branding.color
            }
        },
    },
});
